import { ConstructorBlockType } from '@/interfaces/constructor.interfaces';

export type FinanceProps = ConstructorBlockType<{
  creditPriceLabel?: string;
  tradeInPriceLabel?: string;
}>;

export enum FinanceDrawerEnum {
  Credit = 'credit',
  TradeIn = 'trade-in',
  Insurance = 'insurance',
}
